//This file is automatically rebuilt by the Cesium build process.
export default "const czm_depthRangeStruct czm_depthRange = czm_depthRangeStruct(0.0, 1.0);\n\
";
